export default __webpack_public_path__ + "static/media/021-electric mixer.7092808a.svg";